import React, { Component } from "react";
import Context from "../../Context";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import Strings from "@my-dld/assets/strings";
import FormRow from "@eres/forms-web/FormRow";
import RadioInputField from "@eres/forms-web/RadioInputField";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import { Lookup } from "@eres/ejari-api/Entity";
import { populateLookup } from "../../Utils";
import { HTLookUps } from "../../api/constants";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import InfoPopup from "../../../components/Popup/InfoPopup";

interface Props {
	mode: "edit" | "view";
}

interface State {
	isLoading: boolean;
	statuses?: Lookup[];
	status?: Lookup;
}

class Status extends Component<Props, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
		};
	}

	componentDidMount() {
		populateLookup( HTLookUps.FURNISH_STATUS, {
			onLookup: ( lookup: HTLookUps | string, values: Lookup[] ) => {
				this.setState( {
					statuses: values,
					status: this.getSelectedStatus( values ),
					isLoading: false,
				} );
			}
		} );
	}

	render() {
		if ( this.props.mode === "view" ) {
			return <RenderInfo state={ this.state }/>;
		}
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group field-style",
		};
		const { statuses, isLoading } = this.state;
		return <div className="card mb-3">
			<div className="card-header">
				<span>{ Strings.property_status_at_time_handover }</span>
				<button
					type="button" className="btn btn-default btn-sm greenlist-info"
					data-bs-toggle="modal" data-bs-target="#InfoPopup">
					<i className="fa fa-info-circle"/>
				</button>
			</div>
			<div className="card-body">
				{ isLoading && <span className="spinner-border"/> }
				{ !isLoading && <FormRow { ...filedProps }>
					<RadioInputField
						required={ true }
						id={ "status" }
						label={ "" }
						items={ statuses }
						toIdentifier={ IdExtractor }/>
				</FormRow> }
			</div>
			<InfoPopup
				title={ Strings.property_status_at_time_handover }
				message={ Strings.property_status_at_time_handover_info }/>
		</div>;
	}

	public getStatusId(): Promise<number> {
		const { status } = this.state;
		if ( status ) {
			return Promise.resolve( status.Id );
		}
		return Promise.reject( "Status not valid" );
	}

	private getSelectedStatus( statuses: Lookup[] ) {
		const { request } = this.context;
		if ( request && request.Properties && request.Properties.length > 0 ) {
			const property = request.Properties[ 0 ];
			const sStatus = statuses.find( status => status.Id === property.FurnishingStatusId );
			if ( sStatus ) {
				return sStatus;
			}
		}
		return statuses[ 0 ];
	}
}

function RenderInfo( props: { state: State } ) {
	return <>
		<div className="section-title">
			<h5>{ Strings.property_status_at_time_handover }</h5>
		</div>
		<div className="flex-grid flex-full">
			<div>
				<span>{ Strings.property_status.replace( "<br/>", "" ) }</span>
				<span>{ getLocalValue( props.state.status ) }</span>
			</div>
		</div>
	</>;
}

export default Status;
